<script>
export default {
  name: "StatusAwareComponent",
  props: {
    status: {
      type: String,
      required: false,
      default: 'idle'
    },
    time: {
      type: Number,
      required: false,
      default: 0
    },
  },
  computed: {
    isWorking() {
      return this.status === this.statuses.working;
    },
    isCompleted() {
      return this.status === this.statuses.completed;
    }
  },
  data() {
    return {
      workTime: 0,
      statuses: {
        working: "working",
        completed: "completed",
      },
      mapActionToStatus: {
        shift_start: "working",
        shift_end: "completed"
      }
    }
  }
}
</script>
